export const endpoints = {
    authorized: "company/authorized",
    auth_change_password: "@common/auth/change-password",
    company_module: "company/:companyId/modules",
    company_customer: "company/:companyId/customer",
    company_officer: "company/:companyId/officer",
    company_customer_vehicle: "company/:companyId/customer/vehicle/search",
    company_module_setting: "company/:companyId/module/setting/:moduleId",
    company_module_credential: "company/:companyId/module/credential/:moduleId",
    company_cash: "company/:companyId/cash-register",
    company_cash_movement: "company/:companyId/cash-register/:cashId/movement",
    company_transaction: "company/:companyId/transaction",
    company_transaction_payment: "company/:companyId/transaction/payment",
    company_transaction_payment_mark_paid: "company/:companyId/transaction/payment/:paymentId/mark-paid",
    company_transaction_installment: "company/:companyId/transaction/:transactionId/installment",
    company_customer_transaction: "company/:companyId/customer/:customerId/transaction",
    payment_method: "@common/payment-method",
    company_stock: "company/:companyId/stock",
    company_stock_search: "company/:companyId/stock/search",
    company_stock_category: "company/:companyId/stock/category",
    company_stock_category_tree: "company/:companyId/stock/category/tree",
    company_stock_warehouse: "company/:companyId/stock/warehouse",
    company_stock_warehouse_shelf: "company/:companyId/stock/warehouse/:warehouseId/shelf",
    company_stock_movement: "company/:companyId/stock/:stockId/movement",
    company_stock_movement_transfer: "company/:companyId/stock/:stockId/movement/transfer",
    company_stock_location: "company/:companyId/stock/:stockId/location",
    module: "module",
    module_vehicle_work_order: "company/:companyId/module/vehicle-work-order",
    module_vehicle_work_order_status: "company/:companyId/module/vehicle-work-order/:id/status",
    module_vehicle_work_order_item: "company/:companyId/module/vehicle-work-order/item",
    module_vehicle_work_order_item_batch: "company/:companyId/module/vehicle-work-order/item/batch",
    module_vehicle_work_order_type: "company/:companyId/module/vehicle-work-order/type",
    vehicle_brand: "@common/vehicle/brand",
    vehicle_brand_model: "@common/vehicle/brand/:brandId/model",
    vehicle_brand_model_search: "@common/vehicle/brand/model/search",
    vehicle_year: "@common/vehicle/year",
    stock_unit: "@common/stock/unit",
    module_note: "company/:companyId/module/note",
    module_note_trash: "company/:companyId/module/note/trash",
    module_note_trash_restore: "company/:companyId/module/note/trash/:id/restore",
    module_note_trash_delete: "company/:companyId/module/note/trash/:id",
    module_note_pin: "company/:companyId/module/note/pin",
    module_note_reminder: "company/:companyId/module/note/reminder",
    module_note_category: "company/:companyId/module/note/category",
    module_note_category_batch: "company/:companyId/module/note/category/batch/update",
    module_note_category_tree: "company/:companyId/module/note/category/tree",
    module_note_tag: "company/:companyId/module/note/tag",
    module_agenda: "company/:companyId/module/agenda",
    module_agenda_status: "company/:companyId/module/agenda/:id/status",
    module_widget: "company/:companyId/module/widget",
    user_config: "user-config",
    spotlight_search: "company/:companyId/spotlight/search",
    currency: "@common/localization/currency",
    weather_lookup: "@common/module/weather/lookup",
    weather_location_search: "@common/module/weather/location/search",
    upload: "company/:companyId/upload",
    upload_attach_batch: "company/:companyId/upload/attach/batch",
    upload_detach_batch: "company/:companyId/upload/detach/batch",
    upload_sync_batch: "company/:companyId/upload/sync/batch",
    upload_batch_delete: "company/:companyId/upload/batch/delete",
    file_manager_entities: "company/:companyId/file-manager/entities",
    file_manager_entity_check: "company/:companyId/file-manager/entity-check",
    file_manager_folder: "company/:companyId/file-manager/folder",
    file_manager_folder_batch: "company/:companyId/file-manager/folder/batch/update",
    file_manager_folder_batch_delete: "company/:companyId/file-manager/folder/batch/delete",
    file_manager_folder_tree: "company/:companyId/file-manager/folder/tree",
    file_manager_file: "company/:companyId/file-manager/file",
    file_manager_file_batch: "company/:companyId/file-manager/file/batch/update",
    file_manager_trash: "company/:companyId/file-manager/trash",
    file_manager_trash_folder: "company/:companyId/file-manager/trash/folder",
    storage_quota: "company/:companyId/storage-quota",
    dashboard_statistics: "company/:companyId/dashboard/statistics",
    module_music_library: "company/:companyId/module/music/library",
    module_music_playlist: "company/:companyId/module/music/playlist",
}
